/**
 * Created by lihanying on 2017/6/29.
 */
import { API_DOMAIN } from '../../config'
import 'whatwg-fetch'
import { fetchData, postData } from '../../util/index'
import { fetchClubStorage } from '../ClubStorage/action'
import { fetchClubCommodityType } from '../ClubCommodityType/action'
import { message } from 'antd'
import { startTime, endTime } from '../../util/index'
import {
  GETCLUBCOMMODITY,
  GETQINIUTOKEN,
  GETIMAGEURL,
  GETINSTORAGE,
  GETCOMMODITYTOTAL,
  GETCLUBCOMMODITYOUT,
} from './constants'

export const getClubCommodity = (payload) => {
  return {
    type: GETCLUBCOMMODITY,
    payload,
  }
}
export const getClubCommodityOut = (payload) => {
  return {
    type: GETCLUBCOMMODITYOUT,
    payload,
  }
}
export const getQiniuToken = (payload) => {
  return {
    type: GETQINIUTOKEN,
    payload,
  }
}
export const getImageUrl = (payload) => {
  return {
    type: GETIMAGEURL,
    payload,
  }
}
export const getInStorage = (payload) => {
  return {
    type: GETINSTORAGE,
    payload,
  }
}

export const getCommodityTotal = (payload) => {
  return {
    type: GETCOMMODITYTOTAL,
    payload,
  }
}

//商品列表
export function fetchClubCommodity(body) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/CommodityApi/CommodityList`
    return postData(endpoint, 'POST', JSON.stringify(body)).then((data) => {
      if (body.out) {
        dispatch(getClubCommodityOut(data)) //下架
      } else {
        dispatch(getClubCommodity(data))
      }
      return data
    })
  }
}

//搜索
export function searchData(keyword = false) {
  return (dispatch, getState) => {
    const data = getState().getClubCommodity.clubCommoditySave
    let searchResult = []
    if (data && keyword !== false) {
      searchResult = data.filter(
        (item) =>
          item.commodity_name.indexOf(keyword) !== -1 ||
          item.typename.indexOf(keyword) !== -1
      )
    } else {
      searchResult = data
    }
    dispatch(getClubCommodity(searchResult))
  }
}

//商品分类
export function fetchCommodityType() {
  return (dispatch, getState) => {
    return dispatch(fetchClubCommodityType())
  }
}

//添加商品,商品入库
export function fetchSettingCommodity(a, body, obj, callback) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/CommodityApi/${a}`
    return postData(endpoint, 'POST', JSON.stringify(body)).then((data) => {
      if (data.status === true) {
        dispatch(fetchClubCommodity(obj)) //商品
        dispatch(
          fetchClubStorage('ProcurementAll', {
            start_time: startTime(),
            end_time: endTime(),
            commodity_type: '',
          })
        ) //入库明细
        message.success(data.detail)
        callback()
      } else {
        message.error(data.detail)
      }
    })
  }
}

//修改,删除商品,退库,上架
export function fetchSetCommodity(a, body, obj, callback) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/CommodityApi/${a}`
    return postData(endpoint, 'POST', JSON.stringify(body)).then((data) => {
      if (data.status === true) {
        dispatch(fetchClubCommodity(obj))
        message.success(data.detail)
        callback()
      } else {
        message.error(data.detail)
      }
    })
  }
}

//商品区域
export function fetchCommodityTotal(id) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/CommodityApi/EditCommodity/id/${id}`
    return fetchData(endpoint).then((data) => {
      dispatch(getCommodityTotal(data))
    })
  }
}

export function fetchCommodityAddTotal() {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/CommodityApi/AddCommodity`
    return fetchData(endpoint).then((data) => {
      dispatch(getCommodityTotal(data))
    })
  }
}

//入库流水
export function fetchGetProcurement(id) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/CommodityApi/Procurement/id/${id}`
    return fetchData(endpoint).then((data) => {
      dispatch(getInStorage(data))
    })
  }
}

//获取token
export function fetchQiniuToken() {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/CommodityApi/getQiniuToken`
    return fetchData(endpoint).then((data) => {
      dispatch(getQiniuToken(data))
      return data
    })
  }
}

export function fetchQiniu(form) {
  return (dispatch, getState) => {
    let methods = 'POST'
    let myHeader = {
      method: methods,
      body: form,
    }
    return fetch('https://up-z0.qbox.me/', myHeader)
      .then((res) => res.json())
      .then((data) => {
        dispatch(getImageUrl(data))
        return data
      })
  }
}

//解除冻结
export function fetchRemoveFreeze(id) {
  return (dispatch, getState) => {
    const endpoint = `${API_DOMAIN}/CommodityApi/RemoveFreeze/commodity_id/${id}`
    return fetchData(endpoint).then((data) => {
      if (data.status === true) {
        dispatch(fetchGetProcurement(id))
        message.success(data.detail)
      } else {
        message.error(data.detail)
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/containers/ClubCommodity/action.js